import {useContext, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import {IAM_SERVER_TENANT, IAM_SERVER_TENANT_USER, API_businessman} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from '../../../utils/modal/DetailModal.module.css';
import ProfileSelectModal from "./ProfileSelectModal";

import { uploadProfileImage } from '../../../utils/api/storageApiClient';
import { getCookie } from "../../../utils/cookies/cookies";
import { AuthContext } from "../../../utils/contextapi/AuthProvider";
import { InnocodeButton } from "@intsoft/innocode-core";

/**
 * 테넌트 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const TenantsRegisterModal = ({update}) => {
    const {closeModal} = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    const [selectedProfile, setSelectedProfile] = useState(null); //선택된 프로필
    const [showProfileModal, setShowProfileModal] = useState(false); //  모달 표시 여부
    const [businessNumberValid, setBusinessNumberValid] = useState(true);
    const [businessNumberValidChck, setBusinessNumberValidCheck] = useState(true);

    const [checkClick, setCheckClick] = useState(false);

    const [tenantLogoFile, setTenantLogoFile] = useState(null); //  로고 파일 객체를 저장할 상태
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null); //  로고 미리보기를 위한 상태

    const {
        user
    } = useContext(AuthContext);

    const [formData, setFormData] = useState({
        tenantName: '',
        // detail: '',
        businessName: '',
        businessNumber: '',
        tenantImgUrl:'',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "businessNumber") {
            // 숫자만 추출
            const numeric = value.replace(/[^0-9]/g, "").slice(0, 10);

            // 하이픈 포맷 적용: XXX-XX-XXXXX
            let formatted = numeric;
            if (numeric.length >= 6) {
            formatted = `${numeric.slice(0, 3)}-${numeric.slice(3, 5)}-${numeric.slice(5)}`;
            } else if (numeric.length >= 4) {
            formatted = `${numeric.slice(0, 3)}-${numeric.slice(3)}`;
            }

            setFormData((prev) => ({
            ...prev,
            [name]: formatted
            }));

            // 유효성 체크
            setBusinessNumberValid(numeric.length === 10);
        } else {
            setFormData((prev) => ({
            ...prev,
            [name]: value
            }));
        }
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setTenantLogoFile(file); // 실제 파일 객체 저장
            
            // 미리보기 URL 생성
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogoPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // 테넌트 등록 요청 API
    const handleRegister = async () => {

        if (!selectedProfile) {
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "프로필을 선택해 주세요.",
                confirmText: "확인"
            });
            // showDialog(DialogEnum.DEFAULT, "경고", "프로필을 선택해 주세요.");
            return;
        }

        if (!businessNumberValid) {
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "사업자 번호를\n입력해 주세요.",
                confirmText: "확인"
            });
            // showDialog(DialogEnum.DEFAULT, "경고", "사업자 번호는 10자리 숫자여야 합니다.");
            return;
        }

        if (!businessNumberValidChck) {
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "사업자 번호 검증을\n완료해 주세요.",
                confirmText: "확인"
            });
            // showDialog(DialogEnum.DEFAULT, "경고", "사업자 번호 검증을 완료 해주세요.");
            return;
        }

        for (let key in formData) {
            if (formData[key] === '' && key !== 'tenantImgUrl') {
                setIsNull(true);
                return;
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }))
                setIsNull(true);
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "올바른 값을\n입력해 주세요.",
                    confirmText: "확인"
                });
                // showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }

        setIsNull(false);

        let finalTenantImgUrl = null;
        const userId = getCookie("user_id");
        
        try {
            if (tenantLogoFile) {
                finalTenantImgUrl = await uploadProfileImage(tenantLogoFile, userId, 'zentry_tenant');
            }

            // 2. 업로드된 URL을 포함하여 테넌트 생성 API 호출
            const userData = JSON.parse(user);
            const rawBusinessNumber = formData.businessNumber.replace(/-/g, "");

            const tenantParams = {
                tenantName: formData.tenantName,
                detail: '',
                businessName: formData.businessName,
                businessNumber: rawBusinessNumber,
                status: 'pending',
                createdBy: userId,
                createdByName: userData.name,
                tenantImgUrl: finalTenantImgUrl, // ✅ 추가된 로고 URL
            };

            const url = IAM_SERVER_TENANT + "/create";
            await axios.post(url, tenantParams)
                .then( async (res) =>  {
                    
                    const tenantId = res.data.data.tenantId;

                    const tenantUserParams = {
                        tenantId: tenantId, // 실제 생성 후 ID 넣기
                        profileId: selectedProfile.profile_id, //  여기서 사용
                        tenantType: "owner",
                        userInfo: {},
                    };
                    // //테넌트 참가 유저 프로필 
                    const url = IAM_SERVER_TENANT_USER + "/create";
                    await axios.post(url, tenantUserParams)
                        .then((res) => {
                            showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                            update();
                        })
                })
        } catch (e) {
            console.error("Tenant creation failed:", e);
            showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "테넌트 생성에 실패했습니다.");
        }
    }

    const handleBusinessNumberCheck = async() =>{

        if (!businessNumberValid) {
            showDialog(DialogEnum.DEFAULT, "알림", "사업자번호를 입력해 주세요.");
            return;
        }

        try {
            setCheckClick(true);

            const params = {
                b_no: [formData.businessNumber.replace(/-/g, '')] // 하이픈 제거 및 배열로 감싸기
            };

            const res = await axios.post(
                API_businessman, // URL
                params,          // 데이터
                {
                    headers: {
                        'Content-Type': 'application/json',
                        // 필요 시 다른 헤더 추가 (예: Authorization)
                    }
                }
            );

            // API 응답 데이터 구조에 따라 성공 여부 판단
            if (res.data && res.data.data && res.data.data.length > 0) {
                const result = res.data.data[0];
                
                //  1. b_stt_cd (사업자 상태 코드)가 있는지 먼저 확인
                if (result.b_stt_cd) {
                    // "계속사업자" 등 유효한 상태인지 확인 (예: '01'이 계속사업자)
                    if (result.b_stt_cd === '01') { 
                        showDialog(DialogEnum.SUCCESS, "성공", "확인되었습니다.");
                        // 확인 성공 시 추가 로직 (예: 상태 업데이트)
                        setBusinessNumberValidCheck(true); // 검증 완료 상태로 변경
                    } else {
                        // 휴업자(02), 폐업자(03) 등 다른 상태
                        showDialog(DialogEnum.DEFAULT, "알림", `사업자 상태: ${result.b_stt}`);
                        setBusinessNumberValidCheck(false);
                    }
                } 
                //  2. b_stt_cd가 없고, tax_type에 메시지가 있는 경우 (등록되지 않은 번호)
                else if (result.tax_type && result.tax_type.includes("국세청에 등록되지 않은")) {
                    showDialog(DialogEnum.FAIL, "확인 실패", "국세청에 등록되지 않은 사업자등록번호입니다.");
                    setBusinessNumberValidCheck(false);
                } 
                //  3. 기타 예상치 못한 응답
                else {
                    showDialog(DialogEnum.FAIL, "확인 실패", "유효하지 않은 사업자번호입니다.");
                    setBusinessNumberValidCheck(false);
                }

            } else {
                showDialog(DialogEnum.FAIL, "확인 실패", "사업자번호 조회 결과를 받지 못했습니다.");
                setBusinessNumberValidCheck(false);
            }
        } catch (err) {
            console.error("사업자번호 확인 오류", err);
        } finally {
            setCheckClick(false);
        }
    }

    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>로고 이미지</p>
                    
                    {/* 오른쪽 영역을 감싸는 컨테이너 */}
                    <div className={styles.logoUploadContainer}>
                        {/* 1. 로고 미리보기 */}
                        <img
                            src={logoPreviewUrl || "https://placehold.co/140x140?text=Logo"}
                            alt="테넌트 로고"
                            className={styles.logoPreviewSquare}
                        />
                        
                        {/* 2. 파일 선택 버튼과 설명 */}
                        <div className={styles.logoUploadControls}>
                            <label htmlFor="tenantLogoUpload" className={styles.fileSelectButton}>
                                파일 선택
                            </label>
                            <input
                                id="tenantLogoUpload"
                                type="file"
                                accept=".jpg, .png, .gif" // ✅ 확장자 명시
                                style={{ display: "none" }}
                                onChange={handleLogoChange}
                            />
                            <p className={styles.logoUploadDescription}>
                                테넌트를 대표할 수 있는 이미지로 설정해주세요.
                                <br />
                                권장 크기는 140X140 사이즈이며 500KB 이하의 jpg, png, gif만 등록 가능합니다.
                            </p>
                        </div>
                    </div>
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>테넌트 명</p>
                    <input className={styles.layer__listInput}
                           type={"text"}
                           name={"tenantName"}
                           value={formData.tenantName}
                           onChange={handleChange}/>
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>사업자 명</p>
                    <input className={styles.layer__listInput}
                           type={"text"}
                           name={"businessName"}
                           value={formData.businessName}
                           onChange={handleChange}/>
                </li>
                <li className={styles.businessNumberList}>
                    <div className={styles.businessNumberContainer}>
                        <p lang={"ko"} className={styles.layer__listTit}>사업자 번호</p>
                        <input
                            className={`${styles.layer__listInput} ${!businessNumberValid ? styles.invalid : ""}`}
                            type="text"
                            name="businessNumber"
                            value={formData.businessNumber}
                            onChange={handleChange}
                            placeholder="사업자번호 (예: 123-45-67890)"
                        />
                        <InnocodeButton 
                            disabled={checkClick} 
                            onClick={handleBusinessNumberCheck}
                            designType="primary"
                            theme="line"    
                        >{checkClick ? '검증중...' : '검증'}</InnocodeButton>
                    </div>
                    {/* <button
                        type="button"
                        className={styles.layer__listInput__duplicateCheckBtn}
                        onClick={handleBusinessNumberCheck}
                        disabled={checkClick}
                    >
                        {checkClick ? '검증중...' : '검증'}
                    </button> */}
                </li>
                {/* <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>설명</p>
                    <textarea
                        className={styles.layer__listInput}
                        name={"detail"}
                        value={formData.detail}
                        onChange={handleChange}
                        rows={4} // 원하는 줄 수 조절 가능
                    />
                </li> */}

                <li className={styles.layer__list}>
                <p className={styles.layer__listTit}>
                    프로필 선택
                    {/* <span className={styles.tooltipIcon} title="하나의 계정은 여러 프로필을 가질 수 있으며, 이 중 하나를 테넌트에 참가시킬 수 있습니다.">❔</span> */}
                </p>
                <button
                    className={`${styles.layer__listInput} ${styles.profileSelectButton}`}
                    onClick={() => setShowProfileModal(true)}
                >
                    {selectedProfile ? (
                    <div className={styles.profilePreview}>
                        <img
                        src={selectedProfile.image_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                        alt="프로필 이미지"
                        />
                        <span>{selectedProfile.profile_name}</span>
                    </div>
                    ) : (
                    "프로필 선택"
                    )}
                </button>
                </li>
            </ul>

            {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
            {/* <button className={styles.layer__saveBtn} onClick={handleRegister}>등록</button> */}
            <div className={styles.layer__saveBtnBox}>  
                <InnocodeButton
                    size="md"
                    designType="primary" 
                    fullWidth={true}
                    className={styles.layer__saveBtn}
                    onClick={handleRegister}
                >등록</InnocodeButton>
            </div>

            {/*  모달 표시 */}
            {showProfileModal && (
                <ProfileSelectModal
                onClose={() => setShowProfileModal(false)}
                onSelect={(profile) => {
                    setSelectedProfile(profile);
                    setShowProfileModal(false);
                }}
                />
            )}
        </div>
    )
}